
import setting from '../../../server/settings'
import api from '~api'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

export default {
name: "loan",
components: {
XHeader,Group,Selector,XInput,Toast
},
data() {
return {
baseurl: setting.api_root+ '/api/greenchannel/imgLook?params=',
title: "生源地贷款",
stuinfo:{

},
state:0,
loaninfo:{




},
loan:{




},

imageUrl: [],
showtoast:false,
toasttext:'',
reStatus: false,
relations: [{
key: 1000,
value: "1000元"
}, {
key: 2000,
value: "2000元"
}, {
key: 3000,
value: "3000元"
}, {
key: 4000,
value: "4000元"
}, {
key: 5000,
value: "5000元"
}, {
key: 6000,
value: "6000元"
}, {
key: 7000,
value: "7000元"
}, {
key: 8000,
value: "8000元"
}, {
key: 9000,
value: "9000元"
}, {
key: 10000,
value: "10000元"
}, {
key: 11000,
value: "11000元"
}, {
key: 12000,
value: "12000元"
}, {
key: 13000,
value: "13000元"
}, {
key: 14000,
value: "14000元"
}, {
key: 15000,
value: "15000元"
}, {
key: 16000,
value: "16000元"
}, {
key: 17000,
value: "17000元"
}, {
key: 18000,
value: "18000元"
}, {
key: 19000,
value: "19000元"
}, {
key: 20000,
value: "20000元"
}, {
key: 21000,
value: "21000元"
}, {
key: 22000,
value: "22000元"
}, {
key: 23000,
value: "23000元"
}, {
key: 24000,
value: "24000元"
}, {
key: 25000,
value: "25000元"
}],
}
},
mounted(){
api.post("/api/NewReports/findInformation", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.status==200){
this.stuinfo = res.data.results[0];
if(this.stuinfo.gender=="1"){
this.$set(this.stuinfo,"sex","男")
}else{
this.$set(this.stuinfo,"sex","女")
}
}
})
api.post("/api/greenchannel/selectStuLoanMsg", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.data.code==0){
if(res.data.msg.applyCode=="" || res.data.msg.applyCode==null){
this.state = 0;
}else{
this.loaninfo = res.data.msg;
this.state = 2;
}
}
})

},
methods:{

















checknum(){
if(this.loan.applyMoney == '' || this.loan.applyMoney ==null){
this.toasttext = "请选择贷款金额";
this.showtoast=true;
return false;
}
return true;
},
checkCode1(){
if(this.loan.applyCode == '' || this.loan.applyCode ==null){
this.toasttext = "请输入借款合同号";
this.showtoast=true;
return false;
}
return true;
},
checkCode2(){
if(this.loan.receiptCode == '' || this.loan.receiptCode ==null){
this.toasttext = "请输入回执校验码";
this.showtoast=true;
return false;
}
return true;
},
choosePhoto(file){
var _this = this;

var event = event || window.event;
var file = event.target.files[0];
var reader = new FileReader();

reader.onload = function(e) {
_this.imageUrl = e.target.result; 
}
reader.readAsDataURL(file);












},
deleteImg(index){
if(this.imageUrl.length==1){
this.$refs.cfile.value = '';
this.imageUrl.splice(index,1);
}else{
this.imageUrl.splice(index,1);
}
},
deleteApply(){
this.$vux.loading.show({
text: '加载中，请稍候！'
})
api.post("/api/greenchannel/delete", {"applyType":this.loaninfo.applyType,"typeId":this.loaninfo.typeId,"verifyId":this.loaninfo.verifyId}).then( res=>{
console.log(res.data)
console.log(res.data.code)
if(res.data.code == 0){
this.$router.push({name:'onlinefee',params:{stunum:this.$route.params.stunum}})
}else{
this.$msgbox('温馨提示：',"撤回失败！");
}
this.$vux.loading.hide()
})

},
goedit(){
if(this.checknum() && this.checkCode1() && this.checkCode2() ){
if(this.imageUrl==null || this.imageUrl==[]){

this.toasttext = "国开行贷款回执单不能为空！";
this.showtoast=true;
}else{
this.$vux.loading.show({
text: '加载中，请稍候！'
})
var param = {
'applyMoney': this.loan.applyMoney,
'stuCode': window.localStorage.getItem("stuCode"),
'applyProveBaese64': this.imageUrl,
'applyCode': this.loan.applyCode,
'receiptCode': this.loan.receiptCode,
'idCard': this.stuinfo.idCard
};
api.post("/api/greenchannel/saveStuLoanMsg", param).then( res=>{
if(res.data.code == 0){
var stunum = this.$route.params.stunum;
if(this.reStatus){
this.reStatus = false;
api.post("/api/proces/deleteStatus",{"stuCode":window.localStorage.getItem("stuCode"),"processId":this.$route.params.sort}).then(res =>{
if(res.data!=null){
if(res.data.results==1){
window.localStorage.removeItem('flowdata')
api.post("/api/proces/findProcess", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.data!=null){
var flowdata = [];
for(var i=0;i<res.data.results.length;i++){
var item = {
"sort":res.data.results[i].processId,
"title":res.data.results[i].moduleName,
"urlname":res.data.results[i].urlName,
"skip":res.data.results[i].skip
}
if(res.data.results[i].newStatus=='0'){
item["okflag"] = false;
}else{
item["okflag"] = true;
}
flowdata.push(item);
window.localStorage.setItem('flowdata', JSON.stringify(flowdata))

}
}
})
}
}
})
}

this.$router.push({name:'onlinefee',params:{stunum:stunum}})
}else{
this.$msgbox('温馨提示：',"生源地贷款申请失败！");
}
this.$vux.loading.hide()
})
}
}
},
reedit(){
this.reStatus = true;
this.state=0;
this.loaninfo.applyStatus = '';
},

}
}



// WEBPACK FOOTER //
// ./src/components/newstu/loan.vue